import type { CSSProperties } from "react";
import { useTranslation } from "react-i18next";
import SectionHead from "../SectionHead/SectionHead";
import architect from "../../assets/redesign/certificacoes/cloud-architect.png";
import developer from "../../assets/redesign/certificacoes/cloud-developer.png";
import workspacePro from "../../assets/redesign/certificacoes/workspace-admin-pro.png";
import education from "../../assets/redesign/certificacoes/google-for-education.svg";
import engineer from "../../assets/redesign/certificacoes/cloud-engineer.png";
import dataPractitioner from "../../assets/redesign/certificacoes/data-practitioner.png";
import chromeosAdmin from "../../assets/redesign/certificacoes/chromeos-admin.png";
import workspaceAssoc from "../../assets/redesign/certificacoes/workspace-admin-assoc.png";
import "./Certifications.css";

// Nomes oficiais das certificações do Google (não traduzidos).
// `core`: fração do raio do selo que fica parada no centro (padrão no CSS: .63).
const CERTIFICATIONS: { name: string; level: string; badge: string; core?: number }[] = [
  { name: "Cloud Architect", level: "Professional", badge: architect },
  { name: "Cloud Developer", level: "Professional", badge: developer },
  { name: "Workspace Administrator", level: "Professional", badge: workspacePro },
  { name: "Google for Education", level: "Credential", badge: education, core: 0.595 },
  { name: "Cloud Engineer", level: "Associate", badge: engineer },
  { name: "Data Practitioner", level: "Associate", badge: dataPractitioner },
  { name: "ChromeOS Administrator", level: "Professional", badge: chromeosAdmin, core: 0.36 },
  { name: "Google Workspace Administrator", level: "Associate", badge: workspaceAssoc },
];

export default function Certifications() {
  const { t } = useTranslation();

  return (
    <section className="cz-quals" aria-labelledby="cz-certs-title">
      <div className="cz-quals__block" id="certificacoes">
        <SectionHead id="cz-certs-title" rule title={t("home.certifications_title", "Principais certificações")} />
        {/* Marquee infinito: dois grupos idênticos animados de -50% até 0 (anda para a direita). */}
        <div
          className="cz-certs-marquee"
          role="region"
          aria-label={t("home.certifications_title", "Principais certificações")}
        >
          <div className="cz-certs-marquee__track">
            {[0, 1].map((group) => (
              <div key={group} className="cz-certs-marquee__group" aria-hidden={group === 1 ? true : undefined}>
                {CERTIFICATIONS.map((c) => (
                  <div key={c.name} className="cz-cert">
                    <span
                      className="cz-cert__badge"
                      style={c.core ? ({ "--core": c.core } as CSSProperties) : undefined}
                    >
                      <img src={c.badge} alt="" className="cz-cert__ring" loading="lazy" />
                      <img src={c.badge} alt="" className="cz-cert__core" loading="lazy" />
                    </span>
                    <span className="cz-cert__name">{c.name}</span>
                    <span className="cz-cert__level">{c.level}</span>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
